<template>
    <div
        class="l-ss-c-offer-image-container"
        ref="imgWrapper">
        <div class="l-ss-c-offer-image-wrapper">
            <transition
                name="fade-image"
                mode="out-in">
                <offer-lazy-image
                    :key="currentImageIndex"
                    :src="offerImages[currentImageIndex]"
                    :alt="''"
                    :img-style="style"
                    :error-img="getErrorImg()"/>
            </transition>

            <slot></slot>
        </div>
        <div
            class="l-ss-c-offer-image-indicators"
            v-if="vertical || (!vertical && offerImages.length > 1)">
            <template v-if="offerImages.length > 1">
                <span
                    v-for="imgIndex in offerImages.length"
                    :key="imgIndex"
                    ref="indicator"
                    :data-index="imgIndex - 1"
                    @click.prevent
                    class="l-ss-c-offer-image-indicator"
                    :class="{ 'l-ss-c-offer-image-indicator-active': currentImageIndex === imgIndex - 1 }"></span>
            </template>
        </div>
    </div>
</template>

<script>
    import { ref } from '@vue/composition-api';

    import useImageController from '@/core/components/offer/offer-image/use-image-controller';
    import OfferLazyImage from '@/core/components/offer/offer-image/offer-lazy-image.vue';

    export default {
        name: 'offer-image',
        components: { OfferLazyImage },
        props: {
            offer: {
                type: Object,
            },
            settings: {
                type: Object,
            },
            mobile: {
                type: Boolean,
                default: false,
            },
            vertical: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, { refs }) {
            const { settings } = props;
            const { style } = settings;
            const images = props.offer.pictures || [];

            const { errorImg: customErrorImg, labelsPosition, favouriteIconPosition } = settings;

            const maxImages = settings.max || 1;
            const offerImages = ref(images.slice(0, maxImages));

            let isLocalErrorImg = !customErrorImg;

            const getErrorImg = () => {
                if (isLocalErrorImg) {
                    return 'https://static.shop.megafon.ru/images/goods/img/stub.png';
                } else {
                    return customErrorImg;
                }
            };

            const currentImageIndex = useImageController(refs, offerImages.value, props.mobile);

            return {
                currentImageIndex,
                offerImages,
                labelsPosition,
                favouriteIconPosition,
                style,
                getErrorImg,
            };
        },
    };
</script>
